import List from "@/components/list";
import Bus from "./Bus.js";

const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function() {};

  function downloadFile(data) {
    Bus.$emit("downloadFile", data);
  }
  function removeFile(data) {
    Bus.$emit("removeFile", data);
  }
  // 考勤详情
  function goClassGroup(onlineClass) {
    router.push({
      path: "attendance/attendanceDetail",
      query: { classId: onlineClass.uuid },
    });
  }
  const Deal = ({ props: { vo } }) => {
    const data = vo.row.uuid;
    return (
      <div class="deal-group">
        <el-tooltip
          content="学员考勤"
          placement="top"
          style="margin-right:20px"
        >
          <i
            onClick={() => goClassGroup(data)}
          >学员考勤</i>
        </el-tooltip>
      </div>
    );
  };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main"
    },
    {
      label: "课程名称",
      prop: "courseName",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "授课教师",
      prop: "teacherName",
      minWidth: "120"
    },
    {
      label: "教学形式",
      prop: "teachingFrom",
      minWidth: "120"
    },
    {
      label: "上课时间",
      prop: "teachingStartTime",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "出勤率",
      prop: "attendance",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "应到人数",
      prop: "shouldNum",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "出勤",
      prop: "actualNum",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "迟到",
      prop: "lateNum",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "早退",
      prop: "earlyNum",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "事假",
      prop: "affairsNum",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "病假",
      prop: "sickNum",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "公假",
      prop: "publicNum",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "未签",
      prop: "notNum",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "操作",
      minWidth: "120",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];

  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
